module.exports = __webpack_public_path__ + "img/17.2d687704.jpg";